/**
 * The trip-page designs: the ONE place that lists them.
 *
 * The trip page (SingleRideWithMap) draws designFor(ride.presentation_design)
 * and the ride-settings picker (RideInformation) shows DESIGN_LIST, so neither
 * names a design, and shared components never ask which one is showing.
 *
 * TO ADD A DESIGN
 *   1. src/designs/<id>/: a Layout and a Preview component.
 *   2. Its id in src/utils/rideDesigns.js DESIGN_IDS, and in the backend's
 *      RIDE_PRESENTATION_DESIGNS (travelerblog/ride/views.py) -- the server
 *      refuses ids it does not know.
 *   3. An entry below, and its name/description in translationMixin.js, in
 *      both languages.
 *
 * WHAT A LAYOUT RECEIVES AND KEEPS
 *   props: ride             rideHeader.ride (title, dates, text, media, ...)
 *          days             allRide.attractionsByDay ([] until loaded)
 *          summaryAvailable false for rides in NOT_PRESENTING_THERIDE_SHORTES,
 *                           and until the ride's days have loaded
 *   It draws everything between the page header and the trip plan (the day
 *   cards, which the page keeps so a design change never refetches them).
 *   It must render an element with class .single_ride_sumary: the page's
 *   sticky day map measures it (SingleRideWithMap updateMapSticky).
 *   Shared pieces live in src/components/RideSummary/; place them freely.
 *
 * ENTRY FIELDS
 *   compactHeader  page header without its cover photo and title, buttons only
 */

import { DESIGN_IDS, resolveDesign } from '@/utils/rideDesigns';
import ClassicLayout from './classic/ClassicLayout';
import ClassicPreview from './classic/ClassicPreview';
import PosterLayout from './poster/PosterLayout';
import PosterPreview from './poster/PosterPreview';

const DESIGNS = {
  classic: {
    id: 'classic',
    layout: ClassicLayout,
    preview: ClassicPreview,
    nameKey: 'rideInfoDesignClassic',
    textKey: 'rideInfoDesignClassicText',
    compactHeader: false,
  },
  poster: {
    id: 'poster',
    layout: PosterLayout,
    preview: PosterPreview,
    nameKey: 'rideInfoDesignPoster',
    textKey: 'rideInfoDesignPosterText',
    compactHeader: true,
  },
};

DESIGN_IDS.forEach(id => {
  if (!DESIGNS[id]) throw new Error(`src/designs/index.js: no entry for design '${id}'`);
});

// In DESIGN_IDS order, for the picker.
export const DESIGN_LIST = DESIGN_IDS.map(id => DESIGNS[id]);

// The design to draw for a stored value; unknown values get the default.
export function designFor(value) {
  return DESIGNS[resolveDesign(value)];
}
